module.exports = __webpack_public_path__ + "static/media/white-frame-custom-mat-rendering.847012bd.jpg";